import { Box, Typography } from "@mui/material";
import HeadbulbLogoSVG from "../../SharedComponents/assets/icons/svg/HeadbulbLogoSVG.js";
import '@fontsource/titillium-web';
import { bottomSidebarLinksData, sidebarLinksData } from "../utils/staticData/sidebarLinksData.js";
import { FontEnum } from "../../SharedComponents/utils/enums/FontEnum.js";
import BaseHr from "../../SharedComponents/components/Dividers/BaseHr.js";
import OrderPartLinkDiv from "../../SharedComponents/components/SidebarComponents/OrderPartLinkDiv.js";
import SidebarFooter from "../../SharedComponents/components/SidebarComponents/SidebarFooter.js";
import { OrderPartVariantDivEnum } from "../../SharedComponents/utils/enums/OrderPartDivVariantEnum.js";
import UserCarsList from "./SidebarComponents/UserCarsList.js";
import { useNavigate } from "react-router-dom";



const BuyerSidebar = () => {
    const navigate = useNavigate();

    const currentPathname = window.location.pathname;


    const SidebarHeader = (
        <div style={styles.sidebarHeader}>
            <HeadbulbLogoSVG />
            <Typography style={styles.logoText}>
                SmartPart
            </Typography>
        </div>
    );


    const GetSidebarIcon = (item, color) => {
        let Icon = null;

        if (item.name === "Nalog") {
            //const profilePicUrl = getUserObject().small_profile_image_url;
            Icon = <item.icon source={""} />;
        }

        else {
            Icon = <item.icon color={color} />;
        };

        return Icon;
    };


    const GetSidebarLinkDiv = (item, index) => {
        const styles = {
            mainContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                cursor: 'pointer',
            },
            linkText: {
                fontFamily: FontEnum.TITILIUM_WEB,
                fontSize: '20px',
                fontWeight: 400,
                color: '#FFFFFF'
            }
        };

        const Icon = GetSidebarIcon(item);

        const href = item.href;


        return (
            <div
                key={index}
                style={styles.mainContainer}
                onClick={() => navigate(href)}
            >

                {Icon}

                <p style={styles.linkText}>
                    {item.name}
                </p>
            </div>
        );
    };


    const GetSidebarSelectedLinkDiv = (item, index) => {
        const highlightColor = "rgb(211, 226, 5)";

        const styles = {
            mainContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                border: "1px solid rgb(148, 191, 254)",
                borderRadius: 8
            },
            linkText: {
                fontFamily: FontEnum.TITILIUM_WEB,
                fontSize: '20px',
                fontWeight: 400,
                color: highlightColor
            }
        };

        const Icon = GetSidebarIcon(item, highlightColor);

        return (
            <div
                key={index}
                style={styles.mainContainer}
            >

                {Icon}

                <p style={styles.linkText}>
                    {item.name}
                </p>
            </div>
        );

    };


    const GetProperLinkItem = (item, index) => {
        const conditionOne = currentPathname.startsWith(item.href);
        const conditionTwo = item.href !== "";

        //Later we will not need conditionTwo
        const linkIsSelected = (conditionOne && conditionTwo);

        if (linkIsSelected) {
            return GetSidebarSelectedLinkDiv(item, index);
        }

        else {
            return GetSidebarLinkDiv(item, index);
        };
    };


    return (
        <div style={styles.mainContainer}>
            <div style={styles.mainContainerColumn}>

                {SidebarHeader}

                <div style={styles.hrContainer}>
                    <BaseHr />
                </div>

                <OrderPartLinkDiv variant={OrderPartVariantDivEnum.YELLOW} />

                {sidebarLinksData.map((item, index) => {
                    return GetProperLinkItem(item, index);
                })}
                <BaseHr />

                <UserCarsList />
            </div>


            <div style={styles.mainContainerColumn}>
                {bottomSidebarLinksData.map((item, index) => {
                    return GetProperLinkItem(item, index);
                })}

                <div style={styles.hrContainer}>
                    <BaseHr />
                </div>

                <SidebarFooter />
            </div>
        </div>
    );
};


export default BuyerSidebar;


const styles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        width: 240,
        padding: 20,
        backgroundColor: "black",
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 40,
        overflowY: 'auto',
        overflowX: 'hidden'
    },
    mainContainerColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    },
    hrContainer: {
        marginTop: 20,
        marginBottom: 20
    },
    sidebarHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 20
    },
    logoText: {
        fontFamily: "Titillium Web",
        color: "#ffffff",
        fontSize: "32px",
        fontWeight: 700
    },
    

};
